<div class="region-custom-view custom-view"></div>
<div class="region-items items-view"></div>